import React, { useState, useRef } from 'react';
import { motion, AnimatePresence, useInView } from 'framer-motion';
import { FiX, FiChevronLeft, FiChevronRight, FiHeart, FiCamera, FiZoomIn, FiDownload, FiPackage } from 'react-icons/fi';
import JSZip from 'jszip';
import './Gallery.css';

// Import thumbnails for gallery grid (fast loading) - Old photos
import thumb1 from '../assets/thumbnails/MAH04875.jpg';
import thumb2 from '../assets/thumbnails/MAH05054.jpg';
import thumb3 from '../assets/thumbnails/MAH05520.jpg';
import thumb4 from '../assets/thumbnails/MAH05716.jpg';
import thumb5 from '../assets/thumbnails/MAH05826.jpg';
import thumb6 from '../assets/thumbnails/MAH06053.jpg';
import thumb7 from '../assets/thumbnails/MAH06063.jpg';
import thumb8 from '../assets/thumbnails/MAH06198.jpg';
import thumb9 from '../assets/thumbnails/MAH06762.jpg';
import thumb10 from '../assets/thumbnails/Smile.jpg';

// Import thumbnails - New DSC photos
import thumb11 from '../assets/thumbnails/DSC00742.jpg';
import thumb12 from '../assets/thumbnails/DSC00887.jpg';
import thumb13 from '../assets/thumbnails/DSC01000.jpg';
import thumb14 from '../assets/thumbnails/DSC01075.jpg';
import thumb15 from '../assets/thumbnails/DSC01321.jpg';
import thumb16 from '../assets/thumbnails/DSC01342.jpg';
import thumb17 from '../assets/thumbnails/DSC01372.jpg';
import thumb18 from '../assets/thumbnails/DSC01419.jpg';
import thumb19 from '../assets/thumbnails/DSC01516.jpg';
import thumb20 from '../assets/thumbnails/DSC01533.jpg';
import thumb21 from '../assets/thumbnails/DSC01673.jpg';
import thumb22 from '../assets/thumbnails/DSC01697.jpg';
import thumb23 from '../assets/thumbnails/DSC01864.jpg';
import thumb24 from '../assets/thumbnails/DSC02111.jpg';
import thumb25 from '../assets/thumbnails/DSC02203.jpg';

// Import full size images for lightbox - Old photos
import photo1 from '../assets/MAH04875.jpg';
import photo2 from '../assets/MAH05054.jpg';
import photo3 from '../assets/MAH05520.jpg';
import photo4 from '../assets/MAH05716.jpg';
import photo5 from '../assets/MAH05826.jpg';
import photo6 from '../assets/MAH06053.jpg';
import photo7 from '../assets/MAH06063.jpg';
import photo8 from '../assets/MAH06198.jpg';
import photo9 from '../assets/MAH06762.jpg';
import photo10 from '../assets/Smile.jpeg';

// Import full size images - New DSC photos
import photo11 from '../assets/DSC00742.JPG';
import photo12 from '../assets/DSC00887.JPG';
import photo13 from '../assets/DSC01000.JPG';
import photo14 from '../assets/DSC01075.JPG';
import photo15 from '../assets/DSC01321.JPG';
import photo16 from '../assets/DSC01342.JPG';
import photo17 from '../assets/DSC01372.JPG';
import photo18 from '../assets/DSC01419.JPG';
import photo19 from '../assets/DSC01516.JPG';
import photo20 from '../assets/DSC01533.JPG';
import photo21 from '../assets/DSC01673.JPG';
import photo22 from '../assets/DSC01697.JPG';
import photo23 from '../assets/DSC01864.JPG';
import photo24 from '../assets/DSC02111.JPG';
import photo25 from '../assets/DSC02203.JPG';

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showDownloadMenu, setShowDownloadMenu] = useState(false);
  const [showDownloadAllMenu, setShowDownloadAllMenu] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  // Real wedding photos with thumbnails for grid and full size for lightbox
  const galleryImages = [
    // Original MAH photos
    { id: 1, thumbnail: thumb1, src: photo1, alt: 'Wedding Photo', aspect: 'tall' },
    { id: 2, thumbnail: thumb2, src: photo2, alt: 'Wedding Photo', aspect: 'tall' },
    { id: 3, thumbnail: thumb3, src: photo3, alt: 'Wedding Photo', aspect: 'square' },
    { id: 4, thumbnail: thumb4, src: photo4, alt: 'Wedding Photo', aspect: 'tall' },
    { id: 5, thumbnail: thumb5, src: photo5, alt: 'Wedding Photo', aspect: 'wide' },
    { id: 6, thumbnail: thumb6, src: photo6, alt: 'Wedding Photo', aspect: 'tall' },
    { id: 7, thumbnail: thumb7, src: photo7, alt: 'Wedding Photo', aspect: 'square' },
    { id: 8, thumbnail: thumb8, src: photo8, alt: 'Wedding Photo', aspect: 'tall' },
    { id: 9, thumbnail: thumb9, src: photo9, alt: 'Wedding Photo', aspect: 'wide' },
    { id: 10, thumbnail: thumb10, src: photo10, alt: 'Wedding Photo', aspect: 'tall' },
    // New DSC photos
    { id: 11, thumbnail: thumb11, src: photo11, alt: 'Wedding Photo', aspect: 'square' },
    { id: 12, thumbnail: thumb12, src: photo12, alt: 'Wedding Photo', aspect: 'tall' },
    { id: 13, thumbnail: thumb13, src: photo13, alt: 'Wedding Photo', aspect: 'wide' },
    { id: 14, thumbnail: thumb14, src: photo14, alt: 'Wedding Photo', aspect: 'tall' },
    { id: 15, thumbnail: thumb15, src: photo15, alt: 'Wedding Photo', aspect: 'square' },
    { id: 16, thumbnail: thumb16, src: photo16, alt: 'Wedding Photo', aspect: 'tall' },
    { id: 17, thumbnail: thumb17, src: photo17, alt: 'Wedding Photo', aspect: 'wide' },
    { id: 18, thumbnail: thumb18, src: photo18, alt: 'Wedding Photo', aspect: 'tall' },
    { id: 19, thumbnail: thumb19, src: photo19, alt: 'Wedding Photo', aspect: 'square' },
    { id: 20, thumbnail: thumb20, src: photo20, alt: 'Wedding Photo', aspect: 'tall' },
    { id: 21, thumbnail: thumb21, src: photo21, alt: 'Wedding Photo', aspect: 'wide' },
    { id: 22, thumbnail: thumb22, src: photo22, alt: 'Wedding Photo', aspect: 'tall' },
    { id: 23, thumbnail: thumb23, src: photo23, alt: 'Wedding Photo', aspect: 'square' },
    { id: 24, thumbnail: thumb24, src: photo24, alt: 'Wedding Photo', aspect: 'tall' },
    { id: 25, thumbnail: thumb25, src: photo25, alt: 'Wedding Photo', aspect: 'wide' }
  ];

  const openLightbox = (image, index) => {
    setSelectedImage(image);
    setCurrentIndex(index);
    setShowDownloadMenu(false);
    document.body.style.overflow = 'hidden';
  };

  const closeLightbox = () => {
    setSelectedImage(null);
    setShowDownloadMenu(false);
    document.body.style.overflow = 'unset';
  };

  const nextImage = () => {
    const nextIndex = (currentIndex + 1) % galleryImages.length;
    setCurrentIndex(nextIndex);
    setSelectedImage(galleryImages[nextIndex]);
    setShowDownloadMenu(false);
  };

  const prevImage = () => {
    const prevIndex = (currentIndex - 1 + galleryImages.length) % galleryImages.length;
    setCurrentIndex(prevIndex);
    setSelectedImage(galleryImages[prevIndex]);
    setShowDownloadMenu(false);
  };

  const downloadImage = async (quality) => {
    if (!selectedImage) return;
    
    try {
      const response = await fetch(selectedImage.src);
      const blob = await response.blob();
      
      if (quality === 'compressed') {
        // Create compressed version
        const img = new Image();
        img.src = URL.createObjectURL(blob);
        
        img.onload = () => {
          const canvas = document.createElement('canvas');
          const maxWidth = 1920;
          const maxHeight = 1080;
          let width = img.width;
          let height = img.height;
          
          if (width > height) {
            if (width > maxWidth) {
              height *= maxWidth / width;
              width = maxWidth;
            }
          } else {
            if (height > maxHeight) {
              width *= maxHeight / height;
              height = maxHeight;
            }
          }
          
          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, width, height);
          
          canvas.toBlob((compressedBlob) => {
            const url = URL.createObjectURL(compressedBlob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `wedding-photo-${currentIndex + 1}-compressed.jpg`;
            link.click();
            URL.revokeObjectURL(url);
          }, 'image/jpeg', 0.8);
        };
      } else {
        // Download full size
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `wedding-photo-${currentIndex + 1}-full.jpg`;
        link.click();
        URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.error('Download failed:', error);
    }
    setShowDownloadMenu(false);
  };

  const downloadAllImages = async (quality) => {
    setIsDownloading(true);
    setShowDownloadAllMenu(false);
    
    try {
      const zip = new JSZip();
      const folder = zip.folder('wedding-photos');
      
      for (let i = 0; i < galleryImages.length; i++) {
        const image = galleryImages[i];
        const response = await fetch(image.src);
        const blob = await response.blob();
        
        if (quality === 'compressed') {
          // Compress the image
          const img = new Image();
          const imageUrl = URL.createObjectURL(blob);
          
          await new Promise((resolve) => {
            img.onload = () => {
              const canvas = document.createElement('canvas');
              const ctx = canvas.getContext('2d');
              
              const maxSize = 1920;
              let width = img.width;
              let height = img.height;
              
              if (width > height && width > maxSize) {
                height = (height * maxSize) / width;
                width = maxSize;
              } else if (height > maxSize) {
                width = (width * maxSize) / height;
                height = maxSize;
              }
              
              canvas.width = width;
              canvas.height = height;
              ctx.drawImage(img, 0, 0, width, height);
              
              canvas.toBlob((compressedBlob) => {
                folder.file(`photo-${i + 1}.jpg`, compressedBlob);
                URL.revokeObjectURL(imageUrl);
                resolve();
              }, 'image/jpeg', 0.8);
            };
            img.src = imageUrl;
          });
        } else {
          // Add original full-size image
          folder.file(`photo-${i + 1}.jpg`, blob);
        }
      }
      
      // Generate zip file and download
      const content = await zip.generateAsync({ type: 'blob' });
      const url = URL.createObjectURL(content);
      const link = document.createElement('a');
      link.href = url;
      link.download = `wedding-photos-${quality}.zip`;
      link.click();
      URL.revokeObjectURL(url);
      
    } catch (error) {
      console.error('Download all failed:', error);
      alert('Failed to download images. Please try again.');
    }
    
    setIsDownloading(false);
  };

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.3
      }
    }
  };

  const itemVariants = {
    hidden: { 
      opacity: 0, 
      y: 30,
      scale: 0.9
    },
    visible: { 
      opacity: 1, 
      y: 0,
      scale: 1,
      transition: {
        duration: 0.5,
        ease: "easeOut"
      }
    }
  };

  const lightboxVariants = {
    hidden: { 
      opacity: 0,
      scale: 0.8
    },
    visible: { 
      opacity: 1,
      scale: 1,
      transition: {
        duration: 0.3,
        ease: "easeOut"
      }
    },
    exit: {
      opacity: 0,
      scale: 0.8,
      transition: {
        duration: 0.2
      }
    }
  };

  return (
    <section id="gallery" className="gallery-section" ref={ref}>
      <div className="container">
        <motion.div
          className="section-header"
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
        >
          <motion.div
            className="camera-decoration"
            animate={{
              rotate: [0, 5, -5, 0],
              scale: [1, 1.1, 1]
            }}
            transition={{
              duration: 3,
              repeat: Infinity,
              ease: "easeInOut"
            }}
          >
            <FiCamera />
          </motion.div>
          <h2>Our Memories</h2>
          <p>Capturing the beautiful moments of our journey together</p>
          
          {/* Download All Button */}
          <div className="download-all-container">
            <motion.button
              className="download-all-btn"
              onClick={() => setShowDownloadAllMenu(!showDownloadAllMenu)}
              disabled={isDownloading}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <FiPackage />
              {isDownloading ? 'Preparing Download...' : 'Download All Photos'}
            </motion.button>
            
            {showDownloadAllMenu && (
              <div className="download-all-menu">
                <button 
                  onClick={() => downloadAllImages('original')}
                  disabled={isDownloading}
                >
                  Original Quality (Full Size)
                </button>
                <button 
                  onClick={() => downloadAllImages('compressed')}
                  disabled={isDownloading}
                >
                  Compressed (Smaller Size)
                </button>
                <button 
                  onClick={() => setShowDownloadAllMenu(false)}
                  className="close-download-menu"
                >
                  Cancel
                </button>
              </div>
            )}
          </div>
        </motion.div>

        <motion.div
          className="gallery-grid"
          variants={containerVariants}
          initial="hidden"
          animate={isInView ? "visible" : "hidden"}
        >
          {galleryImages.map((image, index) => (
            <motion.div
              key={image.id}
              className={`gallery-item ${image.aspect}`}
              variants={itemVariants}
              whileHover={{ 
                y: -8, 
                scale: 1.03,
                rotate: Math.random() * 4 - 2,
                transition: { type: "spring", stiffness: 300 }
              }}
              whileTap={{ scale: 0.98 }}
              onClick={() => openLightbox(image, index)}
            >
              <div className="image-container">
                <img 
                  src={image.thumbnail}
                  alt={image.alt}
                  loading="lazy"
                />
                <div className="image-overlay">
                  <motion.div
                    className="overlay-content"
                    initial={{ scale: 0 }}
                    whileHover={{ scale: 1 }}
                    transition={{ type: "spring", stiffness: 400 }}
                  >
                    <FiZoomIn className="zoom-icon" />
                    <span>View Photo</span>
                  </motion.div>
                </div>
                <motion.div
                  className="heart-like"
                  whileHover={{ scale: 1.2 }}
                  whileTap={{ scale: 0.9 }}
                >
                  <FiHeart />
                </motion.div>
              </div>
            </motion.div>
          ))}
        </motion.div>

        <motion.div
          className="gallery-footer"
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8, delay: 1 }}
        >
          <p>More photos will be shared after our special day!</p>
        </motion.div>
      </div>

      {/* Lightbox */}
      <AnimatePresence>
        {selectedImage && (
          <motion.div
            className="lightbox-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={closeLightbox}
          >
            <motion.div
              className="lightbox-container"
              variants={lightboxVariants}
              initial="hidden"
              animate="visible"
              exit="exit"
              onClick={(e) => e.stopPropagation()}
            >
              <button className="lightbox-close" onClick={closeLightbox}>
                <FiX />
              </button>

              <button className="lightbox-nav prev" onClick={prevImage}>
                <FiChevronLeft />
              </button>

              <button className="lightbox-nav next" onClick={nextImage}>
                <FiChevronRight />
              </button>

              <div className="lightbox-download-btn">
                <button onClick={() => setShowDownloadMenu(!showDownloadMenu)}>
                  <FiDownload /> Download
                </button>
                {showDownloadMenu && (
                  <div 
                    style={{
                      position: 'absolute',
                      top: '100%',
                      left: '0',
                      marginTop: '8px',
                      backgroundColor: '#ffffff',
                      borderRadius: '8px',
                      boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
                      padding: '8px',
                      minWidth: '150px',
                      zIndex: 999999
                    }}
                  >
                    <div 
                      onClick={() => downloadImage('full')}
                      style={{
                        padding: '12px 16px',
                        cursor: 'pointer',
                        backgroundColor: '#f5f5f5',
                        marginBottom: '4px',
                        borderRadius: '4px',
                        fontSize: '14px',
                        fontWeight: '600',
                        color: '#000'
                      }}
                      onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#e0e0e0'}
                      onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#f5f5f5'}
                    >
                      📥 Full Size
                    </div>
                    <div 
                      onClick={() => downloadImage('compressed')}
                      style={{
                        padding: '12px 16px',
                        cursor: 'pointer',
                        backgroundColor: '#f5f5f5',
                        borderRadius: '4px',
                        fontSize: '14px',
                        fontWeight: '600',
                        color: '#000'
                      }}
                      onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#e0e0e0'}
                      onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#f5f5f5'}
                    >
                      📥 Compressed
                    </div>
                  </div>
                )}
              </div>

              <div className="lightbox-content">
                <img 
                  src={selectedImage.src}
                  alt={selectedImage.alt}
                />
                <div className="lightbox-info">
                  <p>{currentIndex + 1} of {galleryImages.length}</p>
                </div>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
};

export default Gallery;
